import Model from './Model'
import moment from "moment-timezone";
moment.tz.setDefault('Europe/London');
export default class Message extends Model {
    static async findExternal(channel, id) {
        const data = await Http.get(route('api.v2.messaging.external.message.' + channel, {id}))
        return this.make(data)
    }

    static async find(channelId, id, includeEmail = false) {
        let url = route('api.v2.messaging.message', {channelId, 'messageId': id})
        if (includeEmail) {
            url += '?includeEmail=1'
        }
        const data = await Http.get(url)
        return this.make(data)
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        if (this.createdAt) {
            this.createdAtFormatted = moment(this.createdAt).format('lll')
        }
        if (this.lastSeenAt) {
            this.lastSeenAtFormatted = moment(this.lastSeenAt).format('lll')
        }
    }

    static async channels() {
        let data = await Http.get(route('api.v2.messaging.message.channels'));
        let channels = Message.make(data)
        channels.forEach((i) => {
            i.buildChannelTokens();
            i.lastTyping = []
        });
        return channels
    }

    static async all(channelId) {
        let data = this.make(await Http.get(route('api.v2.messaging.message.by_channel', {channelId})))
        data.forEach((i) => i.buildMessageTokens());
        return data
    }

    static async send(channel, message, id, replyToMessageId, attachments = []) {
        try {
            return await Http.post(route('api.v2.messaging.message.create'), {
                'id': id,
                'to': channel.source,
                'replyToMessageId': replyToMessageId,
                'isGroup': channel.type === 'GROUP',
                'message': message,
                'attachments': attachments
            })
        } catch (e) {
            if ((e.response.status === 503) && (e.response.headers["retry-after"])) {
                const delay = ms => new Promise(res => setTimeout(res, ms));
                await delay(e.response.headers["retry-after"] * 1000)
                await this.send(channel, message, id, attachments);
            } else {
                return e.response
            }
            return e.response
        }
    }

    static async checkHandle(handle) {
        return await Http.get(route('api.v2.messaging.message.handle.valid', {handle}), {})
    }

    static async sendGroup(groupId, handles, message, messageId, groupName = null, attachments = []) {
        try {
            await Http.post(route('api.v2.messaging.message.group.create'), {
                'id': groupId,
                'name': groupName,
                'members': handles,
            })
            return Http.post(route('api.v2.messaging.message.create',), {
                'id': messageId,
                'to': groupId,
                'isGroup': true,
                'message': message,
                'attachments': attachments
            })
        } catch (e) {
            return e.response
        }
    }

    static async removeFromGroup(groupId, userId) {
        try {
            await Http.delete(route('api.v2.messaging.message.group.member.remove', [groupId, userId]))
        } catch (e) {
            return e.response
        }
    }

    static async updateGroup(groupId, groupName) {
        try {
            await Http.post(route('api.v2.messaging.message.group', [groupId]), {
                'id': groupId,
                'name': groupName,
            })
        } catch (e) {
            return e.response
        }
    }

    static async contacts(params = {}) {
        const config = {params: params}
        let data = this.make(await Http.get(route('api.v2.messaging.message.contacts'), config))
        data.forEach((i) => i.buildContactTokens());
        return data
    }

    buildChannelTokens() {
        let tokens = [
            this.name,
//            this.messages ? this.messages.slice(-1)[0].text : null
        ];
        this.tokens = tokens.join('|').toLowerCase();
        this.messages.forEach((message) => {
            let tokens = [
                message.text,
            ];
            message.channel = this
            message.tokens = tokens.join('|').toLowerCase();
        })
    }

    buildMessageTokens() {
    }

    buildContactTokens() {
        let tokens = this.name.split(' ');
        this.tokens = tokens.join('|').toLowerCase();
    }

}
